import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { getMypageCourseList } from "../../../../services/apiCourseApplicant";
import CourseApplicantSearchForm from "./CourseApplicantSearchForm";
import CourseDataTable from "./CourseDataTable";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";

// これまで受講した講座
const AttendedCourseList = () => {
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 申込講座一覧データ
  const [tableData, setTableData] = useState([]);
  // 表示ページ
  const [currentPage, setCurrentPage] = useState(1);
  // 合計取得単位数
  const [acquisitionUnitSum, setAcquisitionUnitSum] = useState(0);
  // ローディング表示
  const [loading, setLoading] = useState(false);
  // 受講した講座
  const AttendedCourse = 2;
  const pathname = useLocation().pathname;

  // 検索フォーム
  const returnSearchForm = () => {
    return (
      <CourseApplicantSearchForm
        displayType={AttendedCourse}
        setSearchCondition={setSearchCondition}
      />
    );
  };

  // タブ
  const returnTab = () => {
    return (
      <div className="p-course-tab" role="menubar">
        <Link
          to="/mypage/course/applied"
          className="p-course-tab__link"
          role="menuitem"
        >
          申込済みの講座
        </Link>
        <button
          type="button"
          className="p-course-tab__link active"
          role="menuitem"
          aria-current="page"
        >
          これまで受講した講座
        </button>
      </div>
    );
  };

  // 申込済みの講座一覧
  const returnDataTable = () => {
    return (
      <CourseDataTable
        displayType={AttendedCourse}
        tableData={tableData}
        acquisitionUnitSum={acquisitionUnitSum}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  };

  const getDispCourseList = async () => {
    // 一覧データ
    let setData = [];
    const url = pathname.split("/").slice(-1)[0];
    const data = await getMypageCourseList(searchCondition, url);
    if (data == undefined || !data) return;
    setCurrentPage(1);
    // 検索終了したらローディング表示終了
    setLoading(false);

    if (data.data_list.length > 0) {
      // 一覧データ作成
      const addData = data.data_list.map((d, index) => {
        return {
          course_id: d.course_id,
          course_name: d.course_name,
          organ: d.organ,
          period: d.period,
          acquisition_unit: d.acquisition_unit,
          course_acquisition_unit: d.course_acquisition_unit,
          status: d.status,
        };
      });
      // 一覧データセット
      setData = setData.concat(addData);
      setTableData(setData);
    }
    setAcquisitionUnitSum(data.acquisition_unit_sum);
  };

  // 初回レンダリング
  useEffect(() => {
    // 一覧データ初期化
    setTableData([]);
    // ローディング表示開始
    setLoading(true);

    // 講座申込情報取得
    (async function () {
      // 講座一覧
      await getDispCourseList();
    })();
  }, [searchCondition]);

  return (
    <div className="l-page-right">
      <div className="l-page-con">
        <h1 className="p-heading01">申込状況・受講履歴</h1>
        {returnTab()}
        {returnSearchForm()}
        <div className="p-course-con">
          <div className="p-course-result01 p-course-panel active">
            {returnDataTable()}
          </div>
        </div>
      </div>
      {loading ? <Loading /> : <></>}
      {loading ? <Progress /> : <></>}
    </div>
  );
};

export default AttendedCourseList;
